import styled from "styled-components";

export const MusicPracticeRoomContainerStyled = styled.div`
  padding: 20px 20px 46px 20px;
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .music_practice_container {
    margin: auto;
    .header_layout {
      margin-bottom: 32px;
    }
    .detail_layout {
      margin-bottom: 16px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
    .musichall_page {
      display: flex;
      flex-wrap: wrap;
      column-gap: 20px;
      row-gap: 32px;
      .musichall_item {
        flex-basis: calc(33.33% - 20px);
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 46px 20px;
    .breadcrumb_layout {
      display: none;
    }
    .music_practice_container {
      .musichall_page {
        .musichall_item {
          flex-basis: calc(50% - 10px);
        }
      }
    }
  }
`;
